import { Directive, input } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ListPagination } from '@workspace/data-types';
import {
  ActionButton,
  DataHeaderAppliedFilter,
  DataHeaderFilter,
  DataListColumn,
  FilterChangedDetection,
} from '../data-table';
import { DtoChangedDetection } from './form.abstract.component';

@Directive()
export abstract class BaseDataTableCoreComponent<TItem, TKey extends string> {
  columns = input.required<DataListColumn<TKey>[]>();
  filters = input.required<DataHeaderFilter<TKey>[]>();
  appliedFilter = input.required<Record<string, string | string[]> | null>();
  currentFilterView = input.required<string | null>();
  items = input.required<TItem[]>();
  count = input.required<number>();
  isLoading = input.required<boolean>();
  pagination = input.required<ListPagination>();
  topButtons = input.required<ActionButton[]>();
  itemActions = input.required<ActionButton[]>();
  mappedFilters = input.required<DataHeaderAppliedFilter<TKey>[]>();
  rowClickable = input<boolean>(false);

  // callbacks
  removeFilter = input<(event: { key: string; value: string }) => void>();
  clearFiltering = input<() => void>();
  triggerFiltering = input<() => void>();
  triggerRefresh = input<() => void>();
  filterViewChanged = input<(view: string) => void>();
  filterChanged = input<(event: FilterChangedDetection) => void>();
  dtoChanged = input<(event: DtoChangedDetection<TItem>) => void>();
  itemClicked = input<(item: TItem, auxClick?: boolean) => void>();
  pageChanged = input<(event: PageEvent) => void>();
  searchChanged = input<(search: string) => void>();
  sortChanged = input<(event: Sort) => void>();
}
